import React, { useState } from "react";
import { IconButton, Popover, Typography } from "@mui/material";
import LinkIcon from "@mui/icons-material/Link";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import SuiInput from "components/SuiInput";
import SuiBox from "components/SuiBox";
import { toast } from "react-toastify";

const CopyDietLinkButton = ({ uid, dietChartId }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const baseUrl = window.location.origin;
  const raw = process.env.PUBLIC_URL || "";
  const prefix =
    raw === "/" ? "" : raw.endsWith("/") ? raw.slice(0, -1) : raw;
  const shareLink = `${baseUrl}${prefix}/dietplan/${uid}/${dietChartId}`;

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(shareLink);
      toast.success("Link copied to clipboard");
    } catch {
      toast.error("Failed to copy link");
    }
  };

  const open = Boolean(anchorEl);
  const id = open ? "copy-link-popover" : undefined;

  return (
    <>
      <IconButton
        size="small"
        onClick={handleClick}
        title="Copy Diet Chart Link"
        sx={{ padding: "3px", marginRight: "5px" }}
      >
        <LinkIcon style={{ color: "#17C1E8" }} />
      </IconButton>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        transformOrigin={{ vertical: "bottom", horizontal: "center" }}
        PaperProps={{
          sx: {
            backgroundColor: "#ffffff",
            boxShadow: 3,
            zIndex: 1300,
            borderRadius: 1,
            minWidth: 100,
            marginRight: "20px"
          },
        }}
        style={{ marginRight: "20px"}}
      >
        <SuiBox sx={{ p: 2 }}>
          <Typography fontSize="small" fontWeight={600} sx={{ mb: 1 }}>
            Copy Diet Chart Share Link
          </Typography>
          <SuiBox
            onClick={copyToClipboard}
            sx={{
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
              backgroundColor: "#f5f5f5",
              px: 1,
              py: 0.5,
              borderRadius: 1,
              "&:hover": {
                backgroundColor: "#e0e0e0",
              },
            }}
          >
            <SuiInput
              disabled
              value={
                shareLink.length > 40
                  ? `${shareLink.slice(0, 40)}...`
                  : shareLink
              }
              sx={{
                mr: 1,
                backgroundColor: "transparent",
                border: "none",
                pointerEvents: "none", // Prevent input from receiving focus
              }}
            />
            <ContentCopyIcon fontSize="small" />
          </SuiBox>
        </SuiBox>
      </Popover>
    </>
  );
};

export default CopyDietLinkButton;
